import { z } from 'zod/mini';
import { OrderLineRuleSchema, OrderLineSchema } from '~/validation/api/packageSessionResponse';
import OptionRuleInterface from './optionRuleInterface';

class DoNotShow implements OptionRuleInterface {
  // eslint-disable-next-line class-methods-use-this
  apply(
    orderLines: z.infer<typeof OrderLineSchema>[],
    targetOrderLines: z.infer<typeof OrderLineSchema>[],
    sourceOrderLines: z.infer<typeof OrderLineSchema>[],
    _rule: z.infer<typeof OrderLineRuleSchema>,
    _pax: number,
  ) {
    // We're hiding everything in either source or target, so merge them
    const doNotShowOrderLines = [...targetOrderLines, ...sourceOrderLines];
    const doNotShowOrderLinesIds = doNotShowOrderLines.map((orderLine) => orderLine.id);

    // Iterate over all order lines and hide the ones that are in
    // the doNotShowOrderLinesIds array
    return orderLines.map((orderLine) => {
      if (doNotShowOrderLinesIds.includes(orderLine.id)) {
        return { ...orderLine, visible: false };
      }

      return orderLine;
    });
  }
}

export default DoNotShow;
